import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/amusementGroup`;


const ApiAmusementGroup = {
  getAll: (params) => {
    const url = `${baseServiceUrl}`;
    return ServiceApi.get(url,{params});
  },
  get: (id) => {
    const url = `${baseServiceUrl}/${id}`;
    return ServiceApi.get(url);
  },
  create: (input) => {
    const url = `${baseServiceUrl}/create-amusementGroup`;
    return ServiceApi.post(url, input);
  },
  update: (id, data) => {
      const url = `${baseServiceUrl}/update-amusementGroup`;
    return ServiceApi.put(url, data);
  },
  delete: (id) => {
    const url = `${baseServiceUrl}/${id}`;
    return ServiceApi.delete(url);
  },
  getAllGroups: () => {
    const url = `${baseServiceUrl}/getAllAmusementGroups`;
    return ServiceApi.get(url);
  },
  getAllAmusementGroupsAndComplex: (params) => {
    const url = `${baseServiceUrl}/getAllAmusementGroupsAndComplex`;
    return ServiceApi.get(url, { params });
  },
  changeOrderAmusementGroup: (params) => {
    const url = `${baseServiceUrl}/changeOrderAmusementGroup`;
    return ServiceApi.post(url,  params );
  },
};

export default ApiAmusementGroup;